<template>
  <svg
    width="10"
    height="11"
    viewBox="0 0 10 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Frame">
      <line
        id="Line 1"
        x1="1.75"
        y1="5.75"
        x2="8.25"
        y2="5.75"
        stroke="#00A8E8"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </g>
  </svg>
</template>
